import { useRouter } from 'next/router'
import { isNil } from 'ramda'

import type { SearchArticlesList } from '@twisto/api-cms'
import { Typography } from '@twisto/components/atoms/typography'
import {
  DropDownList,
  DropdownListItem,
} from '@twisto/components/molecules/autocomplete/dropdown'

import { ArticleSearchBreadcrumb } from './article-search-breadcrumb'

type Props = {
  articles: SearchArticlesList
  opened: boolean
  focusedIndex: number
  className?: string
}

export const ArticleSearchResults = ({
  articles,
  opened,
  focusedIndex,
  className,
}: Props) => {
  const router = useRouter()

  return (
    <DropDownList css={className} opened={opened}>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
      {articles?.map((article, index) => (
        <DropdownListItem
          key={index}
          active={index === focusedIndex}
          onClick={() => {
            if (!isNil(article.path)) {
              router.push(article.path)
            }
          }}
        >
          <Typography variant="b2">{article.headline}</Typography>
          <ArticleSearchBreadcrumb category={article.category} />
        </DropdownListItem>
      ))}
    </DropDownList>
  )
}
